<template>
<v-layout row justify-center wrap xs12 id="titleContainer">
    <v-flex xs12 class="py-4">
        <h1>{{ title }}</h1>

    </v-flex>
    <!-- <v-flex v-if="hasMessage" id="messageContainer" xs12 sm10 md6>
        <p >{{ message }}</p>
    </v-flex> -->


</v-layout>

</template>

<script>
export default {
    name: "InnerViewTitle",
    props: {
        title: {
            type: String,
            required: true,
            default: ""
        },
        message: {
            type: String,
            required: false
        }
    },
    computed: {
        hasMessage: function() {
            return this.message !== undefined && this.message !== "";
        }
    }
}
</script>

<style lang="scss" scoped>
$primary-color: #2174b5 !important;
    #titleContainer {
        text-align: center;
        padding: 15px;
        background-color: $primary-color;
        color: white;
    }

    #messageContainer {
        padding-top: 10px;
    }
</style>